<template>
  <div style="text-align: center">
    <div v-if="!messagesInfo.messages">
      <div class="spinner-border text-secondary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div v-else>
      <div class="container" v-if="messagesInfo">
        <div class="mainContent">
          <div class="top">
            <h1>
              {{ messagesInfo.user2_name }} {{ messagesInfo.user2_last_name }}
            </h1>
            <p
              v-if="
                user &&
                  user.user_profile &&
                  user.user_profile.profile &&
                  user.user_profile.profile.rejection_reason &&
                  user.user_profile.profile.employee_status !== 'ACCEPTED'
              "
            >
              Powód odrzucenia Opiekuna:
              {{ user.user_profile.profile.rejection_reason }}
            </p>
            <div v-if="messagesInfo.message === 'Zero messages'">
              <h1>Nie masz żadnych wiadomości</h1>
            </div>
          </div>
          <div
            class="messages-wrapper"
            id="messages-container"
            ref="messages-container"
            v-show="reversedMessage != null && reversedMessage.length > 0"
          >
            <infinite-loading
              direction="top"
              @infinite="infiniteHandler"
              spinner="bubbles"
            >
              <div slot="no-more"></div>
              <div slot="no-results"></div>
            </infinite-loading>
            <div
              v-for="message in reversedMessage"
              :key="message.id"
              class="messageBlock"
              :style="
                message.user_id === userId
                  ? 'border-bottom-left-radius: 0;  align-self: flex-start;'
                  : 'border-bottom-right-radius: 0;align-self: flex-end;'
              "
            >
              <div
                class="messageInBlock"
                :style="
                  message.type !== 'IMAGE'
                    ? message.user_id === userId
                      ? 'background: #EC1A6B;border-bottom-left-radius: 0;justify-content: flex-start;'
                      : 'background:#090741;border-bottom-right-radius: 0;justify-content: flex-end;'
                    : message.user_id === userId
                    ? 'background: white;border-bottom-left-radius: 0;justify-content: flex-start;'
                    : 'background:white;border-bottom-right-radius: 0;justify-content: flex-end;'
                "
              >
                <!-- AVATARS -->
                <div
                  v-if="
                    !message.from_first_name &&
                      messagesInfo.user2_id === message.user_id
                  "
                  class="messageAuthorUser"
                >
                  <img
                    class="img-avatar"
                    :src="getUrl() + `/api/profile/photo/${message.file_id}`"
                    style="margin-right: 5px"
                  />
                </div>
                <div v-else class="messageAuthorAdmin">
                  <img
                    class="img-avatar"
                    :src="getUrl() + `/api/profile/photo/${message.file_id}`"
                    style="margin-right: 5px"
                  />
                </div>

                <!-- MESSAGE DATE -->
                <div
                  class="messageBlockDateUser"
                  v-if="
                    !message.from_first_name &&
                      messagesInfo.user2_id === message.user_id
                  "
                >
                  {{ formattedDateToString(message.creation_date) }}
                </div>
                <div v-else class="messageBlockDateAdmin">
                  {{ formattedDateToString(message.creation_date) }}
                </div>
                <span
                  v-if="
                    !message.from_first_name &&
                      messagesInfo.user2_id === message.user_id
                  "
                  class="userFirstName"
                  >{{ messagesInfo.user2_name }}</span
                >
                <span v-if="message.from_first_name" class="adminFirstName">{{
                  message.from_first_name
                }}</span>
                <span v-if="message.type === 'TEXT'">
                  {{ message.message }}
                </span>
                <span v-if="message.type === 'IMAGE'">
                  <a target="_blank" :href="message.message">
                    <img
                      :src="message.message"
                      :id="`img-${message.message}`"
                      class="imgInMessage"
                      @error="handleImgError(`img-${message.message}`)"
                    />
                  </a>
                </span>
                <span v-if="message.type === 'ATTACHMENT'">
                  <span
                    class="attachmentText"
                    @click="getFile(message.message, message.id)"
                    >Załącznik do pobrania</span
                  ><i
                    class="fas fa-download attachmentDownloadButton"
                    @click="getFile(message.message, message.id)"
                  ></i>
                </span>
              </div>
            </div>
          </div>

          <form @submit.prevent="handleSubmit($event)" class="sendMessageForm">
            <div class="messageInput">
              <textarea
                :disabled="file"
                v-model="yourMessage"
                name="yourMessage"
                type="text"
                id="YourMessage"
                placeholder="Napisz wiadomość..."
                minlength="1"
                maxlength="2048"
              />
              <div class="charsCounter">
                {{ yourMessage.length }}/{{ messageMaxLength }}
              </div>

              <div class="selectFileInfo" v-if="this.fileName">
                Wybrany plik do wysłania: {{ this.fileName }}
                <i class="fas fa-times" @click="removeFileFromInput()"></i>
              </div>
            </div>
            <div class="messageSend">
              <div>
                <button type="submit">
                  <i class="fas fa-paper-plane"></i>
                </button>
              </div>
              <div>
                <label class="labelAttachment">
                  <i
                    class="fas fa-paperclip"
                    for="file-input"
                    :style="!!yourMessage.length ? 'visibility:hidden' : ''"
                  ></i>
                  <input
                    :disabled="!!yourMessage.length"
                    type="file"
                    @change="getImage($event)"
                    id="file-input"
                    accept="image/*,video/*,.pdf,.peg,.bmp,.gif,.png,.psd,.tiff,.raw,.heif"
                  />
                </label>
              </div>
            </div>
          </form>
        </div>

        <div class="rightContent">
          <div class="userAvatar">
            <img
              :src="
                getUrl() +
                  '/api/profile/photo/' +
                  user.user_profile.profile.file_path
              "
              style="margin-top: 40px"
            />
            <h2 style="margin-top: 20px; margin-bottom: 20px">
              <b
                >{{ user.user_profile.profile.first_name }}
                {{ user.user_profile.profile.last_name }}</b
              >
            </h2>
          </div>

          <div class="userInfo">
            <p v-if="user.user_profile.user.phone">
              <b>Telefon:</b> {{ user.user_profile.user.phone }}
            </p>
            <p v-if="user.user_profile.profile.email">
              <b>Email:</b> {{ user.user_profile.profile.email }}
            </p>
            <p v-if="user.user_profile.profile.postcode">
              <b>Kod pocztowy:</b> {{ user.user_profile.profile.postcode }}
            </p>
            <p v-if="user.user_profile.profile.city">
              <b>Miasto:</b> {{ user.user_profile.profile.city }}
            </p>
            <p v-if="user.user_profile.profile.street">
              <b>Ulica:</b> {{ user.user_profile.profile.street }}
            </p>
            <p v-if="user.user_profile.profile.number1">
              <b>Numer budynku:</b> {{ user.user_profile.profile.number1 }}
            </p>
            <p v-if="user.user_profile.profile.number2">
              <b>Numer mieszkania:</b> {{ user.user_profile.profile.number2 }}
            </p>
          </div>

          <div class="markAsUnreadButton userInfo" @click="markChatAsUnread()">
            Oznacz jako nieprzeczytane
          </div>

          <router-link :to="{ path: '/users/id/' + user.user_profile.user.id }">
            <div
              class="markAsUnreadButton userInfo"
              @click="getUser(user.user_profile.user.id)"
            >
              Przejdź do profilu
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InfiniteLoading from "vue-infinite-loading";
import shared from "../../shared";
import { URL } from "../../axios";
import axios from "axios";
import axiosInstance from "../../axios";
import { convertDataToJsonAndAddToken } from "../../websockets";
export default {
  name: "messages-component",
  data() {
    return {
      yourMessage: "",
      file: null,
      userId: null,
      messages: null,
      timer: "",
      page: 1,
      on_page: 20,
      loading: false,
      fileName: "",
      messageMaxLength: 2048,
      sending: false,
    };
  },
  components: {
    InfiniteLoading,
  },
  computed: {
    reversedMessage() {
      return this.$store.getters.getReversedMessage;
    },
    messagesInfo() {
      return this.$store.getters.getMessagesInfo;
    },
    user() {
      return this.$store.getters.getUserById;
    },
  },
  methods: {
    handleImgError(id) {
      const img = document.getElementById(id);
      const splited = id.split("/");
      splited[splited.length - 1] = `${
        splited[splited.length - 1].split(".")[0]
      }_full.${splited[splited.length - 1].split(".")[1]}`;
      img.src = splited.join("/").replace("img-", "");
    },
    getUser(id) {
      this.$store.dispatch("fetchUserByPhoneOrUserId", {
        param: id,
      });
    },
    markChatAsUnread() {
      const url = `api/chat/${this.$route.params.id}/markAsUnread`;
      axiosInstance
        .put(url)
        .then(() => {
          this.$notify({
            group: "success",
            text: "Wiadomość została oznaczona jako nieprzeczytana",
          });
          clearInterval(this.timer);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    removeFileFromInput() {
      this.fileName = "";
      this.file = null;
    },
    async infiniteHandler($state) {
      this.loading = true;
      await this.$store
        .dispatch("getMessages", {
          user_id: this.$route.params.id,
          page_number: this.page,
          on_page: this.on_page,
        })
        .then(() => {
          if (this.messagesInfo.total > this.on_page) {
            this.on_page += 20;
            $state.loaded();
          } else {
            $state.complete();
          }
          this.loading = false;
        });
    },

    getUrl() {
      return URL;
    },
    scrollToEnd() {
      const container = this.$el.querySelector("#messages-container");
      container.scrollTop = container.scrollHeight;
    },
    async handleSubmit() {
      if (!this.sending) {
        this.sending = true;

        try {
          if (!this.yourMessage && !this.file) {
            this.$notify({
              group: "error",
              text: "Wiadomość nie może być pusta",
            });
            this.sending = false;
            return;
          }
          await this.$store.dispatch("sendMessage", {
            user_id: this.$route.params.id,
            message: this.yourMessage,
            file: this.file,
          });
          this.file = null;
          this.fileName = "";
          this.yourMessage = "";
          await this.$store.dispatch("getMessages", {
            user_id: this.$route.params.id,
          });
          const container = this.$el.querySelector("#messages-container");
          container.scrollTop = container.scrollHeight;
        } catch (error) {
          console.log(error);
        } finally {
          setTimeout(() => (this.sending = false), 3000);
        }
      }
    },
    getImage(e) {
      if (e.target.files[0].size > 10000000) {
        this.$notify({
          group: "error",
          text: "Maksymalny rozmiar załącznika to 10MB",
        });
        return;
      }
      e.preventDefault();
      this.file = e.target.files[0];
      this.fileName = this.file.name;
    },
    async getFile(id, messageId) {
      axios({
        url: id,
        method: "GET",
        responseType: "blob",
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", messageId + "." + id.split(".").pop());
        document.body.appendChild(link);
        link.click();
      });
    },
  },
  created() {
    this.formattedDate = shared.formattedDate;
    this.formattedDateToString = shared.formattedDateToString;

    this.userId = this.$route.params.id;
    this.$store.dispatch("getUserById", {
      userId: this.userId,
    });
    this.$store.dispatch("fetchUserByPhoneOrUserId", {
      param: this.userId,
      withoutRedirect: true,
    });
  },

  mounted() {
    this.sockets.subscribe("NEW_MESSAGE_EVENT", (data) => {
      const routeParamId = this.$router.currentRoute?.params?.id;
      if (routeParamId && routeParamId === data?.user_id) {
        this.$socket.emit(
          "ALL_MESSAGES_EVENT",
          convertDataToJsonAndAddToken({
            user_to_id: data.user_id,
            to_admin: false,
            page_number: this.page,
            on_page: this.on_page,
          })
        );
        setTimeout(() => {
          const container = document.querySelector("#messages-container");
          container.scrollTop = container.scrollHeight;
        }, 100);
      }
    });

    const document = this.$el;
    this.$store
      .dispatch("getMessages", {
        user_id: this.$route.params.id,
        page_number: this.page,
        on_page: this.on_page,
      })
      .then(() => {
        const container = document.querySelector("#messages-container");
        container.scrollTop = container.scrollHeight;
        this.$store.dispatch("fetchNumberOfUnreadMessagesCounter");
      });
  },
};
</script>

<style scoped>
.container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.userAvatar {
  border-radius: 5px;
  -webkit-box-shadow: 0px 0px 30px 5px rgba(176, 176, 176, 1);
  -moz-box-shadow: 0px 0px 30px 5px rgba(176, 176, 176, 1);
  box-shadow: 0px 0px 30px 5px rgba(176, 176, 176, 1);
}
.userInfo {
  margin-top: 40px;
  border-radius: 5px;
  -webkit-box-shadow: 0px 0px 30px 5px rgba(176, 176, 176, 1);
  -moz-box-shadow: 0px 0px 30px 5px rgba(176, 176, 176, 1);
  box-shadow: 0px 0px 30px 5px rgba(176, 176, 176, 1);
}
.rightContent {
  width: 300px;
  margin-left: 100px;
  height: 700px;
}
.mainContent {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 650px;
}
.form-group {
  width: 100%;
  margin: 40px auto;
}
.top {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.button-wrapper {
  width: 200px;
  justify-content: center;
  margin: auto;
}

.messages-wrapper {
  overflow-y: scroll;
  height: 500px;
  scrollbar-color: grey white;
  scrollbar-width: thin;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: white;
  margin: 0;
  padding: 0;
  width: 650px;
  justify-items: center;
  align-content: center;
}
.messageInBlock {
  display: flex;
  justify-content: center;
  width: auto;
  border-radius: 10px;
  position: relative;
  margin-left: 50px;
  margin-right: 50px;
  max-width: 350px;
  min-height: 50px;
  align-items: center;
  padding: 10px;
  min-width: 70px;
}
.messageAuthorUser img {
  border-radius: 50px;
  width: 45px !important;
  height: 45px !important;
}
.messageAuthorUser,
.messageAuthorAdmin {
  border-radius: 50px;
  width: 45px !important;
  height: 45px !important;
}
.messageBlock {
  font-family: "Poppins", sans-serif;
  position: relative;
  margin-top: 40px;
  border: 0;
  display: flex;
  position: relative;
}
.messageAuthorUser {
  position: absolute;
  left: -55px;
  bottom: 5px;
}
.messageAuthorAdmin {
  position: absolute;
  right: -46px;
  bottom: -10px;
}
.messageBlockDateUser {
  position: absolute;
  bottom: -24px;
  left: -20px;
  color: rgb(126, 124, 124);
  min-width: 150px;
}
.messageBlockDateAdmin {
  position: absolute;
  bottom: -24px;
  right: -20px;
  color: rgb(126, 124, 124);
  min-width: 150px;
}

.message-image {
  max-height: 100px !important;
  width: 100px !important;
  height: 100px !important;
  margin-bottom: 5px;
}
.imageMessage {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.taskMessageAttachment {
  border-radius: 50px;
}
.adminFirstName {
  position: absolute;
  top: -17px;
  color: #090741;
  right: 10px;
}
.userFirstName {
  position: absolute;
  top: -17px;
  color: #090741;
}
.messageAuthorUser {
  width: 100px;
  height: 100px;
  border-radius: 5px;
}
.attachmentDownloadButton {
  cursor: pointer;
  margin-left: 5px;
}
.attachmentText {
  cursor: pointer;
}
.sendMessageForm {
  width: 100%;
  margin-top: 50px;
  position: relative;
  display: flex;
}
.sendMessageForm input {
}
#YourMessage {
  width: 95%;
  border-radius: 20px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border: none;
  min-height: 150px;
  height: auto;
  background: #ebe6e6;
  outline: none;
  padding: 10px;
  padding-left: 10px;
  position: relative;
  text-align: center;
}
#file-input {
  visibility: hidden;
}
.messageInput {
  width: 100%;
  position: relative;
}
.messageSend button {
  border-radius: 70px;
  border: none;
  width: 40px;
  height: 40px;
  background: #ebe6e6;
  outline: none;
  padding: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
}
.messageSend i {
  font-size: 23px;
  color: gray;
}
.messageSend i:hover {
  font-size: 24px;
  color: #090741;
}
.messageSend {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
}
.messageSend div {
  width: 50px;
}
.selectFileInfo {
  position: absolute;
  right: 20px;
  bottom: -10px;
  font-size: 11px;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
}
.selectFileInfo i {
  color: tomato;
  margin-left: 5px;
  cursor: pointer;
}
.selectFileInfo i:hover {
  color: red;
  margin-left: 5px;
}

/* SCROLL */
.messages-wrapper::-webkit-scrollbar {
  width: 8px;
}
.messages-wrapper::-webkit-scrollbar-track {
  background: #f1f1f1;
}
.messages-wrapper::-webkit-scrollbar-thumb {
  background: #888;
}
.messages-wrapper::-webkit-scrollbar-thumb:hover {
  background: #555;
}
.charsCounter {
  position: absolute;
  bottom: 15px;
  right: 25px;
  font-size: 9px;
}
.labelAttachment {
  display: unset;
}
.messageSend input,
.messageSend label {
  width: 50px;
}
.messageSend input:hover,
.messageSend label:hover {
  cursor: pointer;
}
.userInfo {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 20px;
}
.rightContent img {
  border-radius: 100px !important;
  width: 80px !important;
  height: 80px !important;
}
.markAsUnreadButton {
  align-items: center;
  justify-content: center;
  height: 30px;
  color: black !important;
  text-decoration: unset;
}
.markAsUnreadButton:hover {
  background: rgb(218, 213, 213);
  cursor: pointer;
}
a:hover {
  text-decoration: none;
}

@media only screen and (max-width: 1366px) {
  .container {
    display: block;
  }
  .mainContent {
    width: 100%;
  }
  .rightContent {
    margin-left: 0;
    width: 100%;
    display: flex;
  }
  .rightContent div {
    width: 30%;
    margin: 10px;
    height: 230px;
  }
}
.imgInMessage {
  width: 100px;
}
</style>
